import React from "react"
import { Button } from "@mui/material"
import { PaymentsOutlined } from "@mui/icons-material"
import { initials } from "../../StockManager/classroom/helpers"

const buttonSx = { textTransform: "none", borderRadius: "8px", px: 1.5, whiteSpace: "nowrap" }

function Avatar({ name }) {
    return (
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-indigo-50 text-xs font-semibold text-indigo-600">
            {initials(name)}
        </span>
    )
}

function CollectButton({ student, onCollect }) {
    return (
        <Button
            size="small"
            variant="outlined"
            color="success"
            startIcon={<PaymentsOutlined fontSize="small" />}
            onClick={() => onCollect(student)}
            sx={buttonSx}
        >
            Monthly fee
        </Button>
    )
}

/** Students of one class: a table on wide screens and stacked rows on phones. */
export default function FeeStudentList({ students, onCollect }) {
    return (
        <>
            {/* Wide screens */}
            <div className="hidden overflow-x-auto md:block">
                <table className="w-full min-w-[640px] text-left text-sm">
                    <thead>
                        <tr className="border-b border-slate-200 text-xs font-semibold uppercase tracking-wide text-slate-500">
                            <th className="w-20 py-3 pl-5 pr-2 font-semibold">Roll no</th>
                            <th className="px-3 py-3 font-semibold">Student</th>
                            <th className="px-3 py-3 font-semibold">Father</th>
                            <th className="py-3 pl-3 pr-5 text-right font-semibold">Fees</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-100">
                        {students.map((student) => (
                            <tr
                                key={student.id ?? student.roll_no}
                                onClick={() => onCollect(student)}
                                className="cursor-pointer align-middle hover:bg-slate-50/70"
                            >
                                <td className="py-3 pl-5 pr-2">
                                    <span className="inline-flex min-w-[2rem] justify-center rounded-md bg-slate-100 px-2 py-0.5 text-xs font-semibold tabular-nums text-slate-700">
                                        {student.roll_no ?? "-"}
                                    </span>
                                </td>
                                <td className="max-w-[320px] px-3 py-3">
                                    <div className="flex min-w-0 items-center gap-3">
                                        <Avatar name={student.name} />
                                        <div className="min-w-0">
                                            <div className="truncate font-medium text-slate-800">{student.name || "-"}</div>
                                            <div className="truncate text-xs text-slate-500">{student.email || "-"}</div>
                                        </div>
                                    </div>
                                </td>
                                <td className="max-w-[200px] truncate px-3 py-3 text-slate-700">{student.father_name || "-"}</td>
                                <td className="py-3 pl-3 pr-5 text-right" onClick={(e) => e.stopPropagation()}>
                                    <CollectButton student={student} onCollect={onCollect} />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Phones */}
            <ul className="divide-y divide-slate-100 md:hidden">
                {students.map((student) => (
                    <li key={student.id ?? student.roll_no} className="flex items-center gap-3 px-4 py-3">
                        <Avatar name={student.name} />
                        <div className="min-w-0 flex-1">
                            <div className="truncate font-medium text-slate-800">{student.name || "-"}</div>
                            <div className="text-xs tabular-nums text-slate-500">Roll {student.roll_no ?? "-"}</div>
                        </div>
                        <CollectButton student={student} onCollect={onCollect} />
                    </li>
                ))}
            </ul>
        </>
    )
}
